import React from 'react';
import PropTypes from 'prop-types';

import CustomSelect from '../../../components/Select/CustomSelect';
import Card from '../../../components/Card/Card';
import { articleMarketplacesList } from '../../../constants/articleMarketplaces';

const cardBodyClassName = 'px-[30px] pb-[30px]';
const cardContainerClassName = 'flex-none mb-[40px]';

const ArticlesMarketplace = ({ value, onSelect }) => (
  <Card
    headerTitle="Marketplace"
    showHeader
    styleBodyContainer={cardBodyClassName}
    styleContainer={cardContainerClassName}
    headerBordered={false}
  >
    <CustomSelect
      options={articleMarketplacesList}
      isSearchable={false}
      placeholder="Select marketplace"
      onChange={onSelect}
      value={[value]}
    />
  </Card>
);

ArticlesMarketplace.propTypes = {
  value: PropTypes.shape({}),
  onSelect: PropTypes.func,
};

ArticlesMarketplace.defaultProps = {
  onSelect: () => {},
  value: null
};

export default ArticlesMarketplace;
